import { render, staticRenderFns } from "./toDoListMain.vue?vue&type=template&id=4b8a6e6b&scoped=true"
import script from "./toDoListMain.vue?vue&type=script&lang=js"
export * from "./toDoListMain.vue?vue&type=script&lang=js"
import style0 from "./toDoListMain.vue?vue&type=style&index=0&id=4b8a6e6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a6e6b",
  null
  
)

export default component.exports